import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Menu, Upload } from "antd";

import Localize from "./localize";


const PhotoSourceUpload = ({ children, className = "", disabled, ...uploadProps }) => {
    const cameraRef = useRef(null);
    const galleryRef = useRef(null);
    const triggerRef = useRef(null);
    const [ visible, setVisible ] = useState(false);
    const [ supportsCapture ] = useState(() => (
        typeof document !== "undefined" && "capture" in document.createElement("input")
    ));
    const isDisabled = !!(disabled || children.props.disabled);

    useEffect(() => {
        if (isDisabled) setVisible(false);
    }, [ isDisabled ]);

    if (!supportsCapture) {
        return <Upload {...uploadProps} className={ className } disabled={ isDisabled }>{ children }</Upload>;
    }

    const selectSource = ({ key }) => {
        if (isDisabled) return;

        const sourceRef = key === "camera" ? cameraRef : galleryRef;
        triggerRef.current?.querySelector("button")?.focus();
        // rc-upload replaces the input after each selection. Resolve it at click time,
        // within the user gesture, and keep it mounted while the native picker is open.
        sourceRef.current?.querySelector('input[type="file"]')?.click();
        setVisible(false);
    };

    return (
        <div
            className={ `photo-source-upload ${className}` }
            ref={ triggerRef }
            onKeyDown={ (event) => {
                if (visible && event.key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                    setVisible(false);
                    triggerRef.current?.querySelector("button")?.focus();
                }
            } }
        >
            <Dropdown
                trigger={[ "click" ]}
                disabled={ isDisabled }
                visible={ visible && !isDisabled }
                onVisibleChange={ (nextVisible) => setVisible(nextVisible && !isDisabled) }
                overlayClassName="drop-more-menu photo-source-menu"
                overlay={
                    <Menu
                        onClick={ selectSource }
                        items={[
                            {
                                key: "camera",
                                disabled: isDisabled,
                                label: <Localize>PHOTO_SOURCE.TakePhoto</Localize>
                            },
                            {
                                key: "gallery",
                                disabled: isDisabled,
                                label: <Localize>PHOTO_SOURCE.ChooseFromGallery</Localize>
                            }
                        ]}
                    />
                }
            >
                { React.cloneElement(children, {
                    disabled: isDisabled,
                    "aria-haspopup": "menu",
                    "aria-expanded": visible && !isDisabled
                }) }
            </Dropdown>
            <div hidden ref={ cameraRef }>
                <Upload {...uploadProps} disabled={ isDisabled } capture="environment" />
            </div>
            <div hidden ref={ galleryRef }>
                <Upload {...uploadProps} disabled={ isDisabled } capture={ undefined } />
            </div>
        </div>
    );
};

export default PhotoSourceUpload;
